import { render, staticRenderFns } from "./fullQuestionEditorModal.vue?vue&type=template&id=32b9faf3&scoped=true"
import script from "./fullQuestionEditorModal.vue?vue&type=script&lang=js"
export * from "./fullQuestionEditorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b9faf3",
  null
  
)

export default component.exports